var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotifyHeroBurst02 = function SvgSpotifyHeroBurst02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1877 1535",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h1877v1535H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#b)",
    d: "M901.107 31l194.675 74.7-761.197 1982.216 734.093-1504.528L1843 960.903 742.201 3217-32.12 2839.484l6.405-13.127-127.799-49.038 2.929-7.63L-600 2597.244 76.067 836.713l449.413 172.446z"
  }))));
};
export default SvgSpotifyHeroBurst02;